import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'sasity_colorblind_mode';

export function useColorblindMode() {
  const [enabled, setEnabled] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'on';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (enabled) {
      document.documentElement.classList.add('colorblind');
    } else {
      document.documentElement.classList.remove('colorblind');
    }
  }, [enabled]);

  const toggle = useCallback(() => {
    setEnabled((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, next ? 'on' : 'off');
      } catch {
        // localStorage unavailable
      }
      return next;
    });
  }, []);

  return { enabled, toggle };
}
